import { Language } from "@omni/schemas/config/language.schema";
import { Locale } from "@omni/types/enums/locale.enum";

export const $LocalesModuleName = "locales";

export type TLocalesState = {
    current?: Locale;
    languages: Array<Language>;
};
